import styled from 'styled-components';
import {
  GRAPHITE_COLOR,
  ICE_COLOR,
  LG_COLOR,
  MAIN_BLUE_COLOR,
  PLATINUM_COLOR,
  SOFT_GREY_COLOR,
} from 'containers/App/constants';

export const ApplicationCredentialManagementPageStyles = styled.div`
  background: ${ICE_COLOR};
  min-height: 100%;
  padding: 24px;

  .credential-shell {
    margin: 0 auto;
    max-width: 1400px;
  }

  .credential-header,
  .credential-panel,
  .credential-filter-panel {
    background: #fff;
    border: 1px solid #dde2e8;
    border-radius: 8px;
    box-shadow: 0 8px 22px rgba(65, 70, 80, 0.08);
  }

  .credential-header {
    align-items: flex-start;
    display: flex;
    gap: 18px;
    justify-content: space-between;
    margin-bottom: 18px;
    padding: 22px 24px;
  }

  .credential-eyebrow {
    color: ${LG_COLOR};
    font-size: 0.76rem;
    font-weight: 700;
    letter-spacing: 0;
    margin-bottom: 6px;
    text-transform: uppercase;
  }

  .credential-title {
    color: ${GRAPHITE_COLOR};
    font-size: 1.65rem;
    font-weight: 600;
    line-height: 1.25;
    margin: 0;
  }

  .credential-subtitle {
    color: #66707d;
    margin: 8px 0 0;
    max-width: 760px;
  }

  .credential-filter-panel {
    margin-bottom: 18px;
    padding: 18px;
  }

  .credential-filter-label {
    color: ${GRAPHITE_COLOR};
    font-size: 0.84rem;
    font-weight: 600;
    margin-bottom: 8px;
    white-space: nowrap;
  }

  .credential-panel {
    overflow: hidden;
  }

  .credential-panel-header {
    align-items: center;
    background: ${SOFT_GREY_COLOR};
    border-bottom: 1px solid #d9dde3;
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 18px;
  }

  .credential-panel-title {
    color: ${GRAPHITE_COLOR};
    font-size: 1rem;
    font-weight: 700;
    margin: 0;
  }

  .credential-table-scroll {
    max-height: calc(100vh - 360px);
    min-height: 320px;
    overflow: auto;
  }

  .credential-table-scroll table {
    min-width: 980px;
  }

  .credential-table-scroll th {
    background: #f3f5f8;
    border-bottom: 1px solid #d9dde3;
    color: ${GRAPHITE_COLOR};
    font-size: 0.78rem;
    position: sticky;
    text-transform: uppercase;
    top: 0;
    z-index: 4;
  }

  .credential-table-scroll td {
    position: relative;
    z-index: 0;
  }

  .credential-password-cell,
  .credential-password-cell .form-control,
  .credential-password-cell .btn {
    position: relative;
    z-index: 0;
  }

  .credential-password-cell {
    min-width: 220px;
  }

  .credential-password-mask {
    color: ${GRAPHITE_COLOR};
    font-family: monospace;
    font-size: 0.94rem;
  }

  .credential-actions {
    min-width: 144px;
  }

  .credential-empty-state,
  .credential-loading-state {
    align-items: center;
    color: #66707d;
    display: flex;
    justify-content: center;
    min-height: 260px;
  }

  .credential-submit.btn-primary,
  .credential-add-button.btn-primary {
    background-color: ${LG_COLOR};
    border-color: ${LG_COLOR};
  }

  .credential-submit.btn-primary:hover,
  .credential-submit.btn-primary:focus,
  .credential-add-button.btn-primary:hover,
  .credential-add-button.btn-primary:focus {
    background-color: #8d012d;
    border-color: #8d012d;
  }

  .form-control:focus,
  .form-select:focus {
    border-color: ${MAIN_BLUE_COLOR};
    box-shadow: 0 0 0 0.18rem rgba(22, 81, 119, 0.16);
  }

  @media (max-width: 991px) {
    padding: 16px;

    .credential-header {
      flex-direction: column;
      padding: 18px;
    }

    .credential-table-scroll {
      max-height: none;
    }
  }
`;
